
import './App.css';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Pages/Home';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import Dashboard from './Pages/Dashboard';
import { useAuthContext } from './Hooks/useauthContext';
import PaymentSuccess from './Pages/PaymentSuccess';
import Pricing from './Pages/Pricing';
import Products from './Pages/Products';
import ResetPasswordPage from './Pages/ResetPassword';
import AboutUs from './Pages/AboutUs';
import ContactUs from './Pages/ContactUs';

import { useEffect } from 'react';
import ForgotPassword from './Pages/ForgotPassword';


function App() {
  const { user, authIsReady } = useAuthContext();

  if (!authIsReady) {
    // You can replace this with a nicer loading component if desired.
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" />} />
        <Route path="/login" element={<Login />} />
        {/* <Route path="/register" element={<Signup />} /> */}
        <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/" replace />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/products" element={<Products />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />}/>
      </Routes>
    </Router>
  );
}

export default App;
